import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EstimatesService } from 'src/app/services/estimates/estimates.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { LocationService } from 'src/app/services/location/location.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Options } from '@angular-slider/ngx-slider';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Subscription, of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { RoleType } from 'src/app/helpers/enums/role-type.enum';
import { InformationService } from 'src/app/services/information/information.service';
import { TemplateModalComponent } from 'src/app/common/modals/template-modal/template-modal.component';

@Component({
  selector: 'app-estimates',
  templateUrl: './estimates.component.html',
  styleUrls: ['./estimates.component.scss']
})
export class EstimatesComponent implements OnInit {
  public loaded: boolean = false;
  public submitted: boolean = false;
  public submitLoad: boolean = false;
  public lang: string = null;
  public roleType = RoleType;

  sliderMin: number;
  highValue: number = 0;
  options: Options = {
    floor: 0,
    ceil: 0
  };

  modalRef?: BsModalRef;

  public estimateForm: UntypedFormGroup = null;
  public estimatedPurchasePrice: string | number = null;
  public estimatedSellingPrice: string | number = null;
  public wholeSaleRange: number | string = null;
  public retailRange: number | string = null;
  public ratingStatus: string = null;
  public cities: object[] = [];
  public buyPrice: number = 0;
  // public estimatePriceCalculateData: any[] = [];
  public estimateDetails: any = null;
  public activePurchaseSuggestion: number;
  public activeSaleSuggestion: number;

  public vehicleDetails: object = {};
  public vehicleInformation: object = {};
  public cod: number = null;
  public itemCode: string = null;

  public role: any = null;
  public userData: any = null;
  public subscriptions: Subscription[] = [];
  public disableForm: boolean = false;

  constructor(
    public router: Router,
    public location: Location,
    public formBuilder: UntypedFormBuilder,
    public estimateService: EstimatesService,
    public sharedService: SharedService,
    public userService: UserService,
    public authService: AuthService,
    public localeService: LocaleService,
    public locationService: LocationService,
    public toastr: ToastrService,
    private modalService: BsModalService,
    public informationService: InformationService
  ) {
    this.getUserData();
    this.estimateForm = this.formBuilder.group({
      purchase_type: [''],
      // , [Validators.required]
      market_value: [''],
      repair_total_cost: [''],
      profit_percent: [''],
      estimated_selling_price: [''],
      estimated_purchase_price: [''],
      city_id: [''],
      buy_decision: [''],
      sell_decision: [''],
      buy_price: [''],
      sell_price: [''],
      purchase_order: [''],
      sales_order: ['']
    });
  }

  ngOnInit(): void {
    this.getInfo();
    this.getCities();
    this.getVehicleInfo();
    this.checkAlert();
    this.getPurchaseType();
    this.localeService.localeSubject.subscribe((res) => {
      if (res) {
        this.lang = res;
      }
    });

    // START => getting report status of a vehicle from API and then disable the form
    const payload = { vehicle_id: this.sharedService.getVehicleId };

    // this.informationService.getVehicleStatus(payload).subscribe((res: object) => {
    //   const vehicleStatus = Object.values(res['data'])

    //   this.disableForm= vehicleStatus.every((status: boolean) => status === true)
    //   // if(this.disableForm === true){
    //   //   this.estimateForm.disable()
    //   // }
    // })
    // END
  }

  get formData() {
    return this.estimateForm.controls;
  }

  getUserData() {
    const userDataSub = this.authService.userSubject.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'admin';
      // this.role = user && user.user_data ? user.user_data.role : 'purchaser';
    });

    this.subscriptions.push(userDataSub);
  }

  ratingStatusChecker(value: number) {
    if (value >= 5) {
      this.ratingStatus = 'excellent';
    } else if (value >= 4.5 && value !== 5) {
      this.ratingStatus = 'good';
    } else if (value >= 4 && value <= 4.49) {
      this.ratingStatus = 'v_fair';
    } else if (value >= 3.5 && value <= 3.999) {
      this.ratingStatus = 'fair';
    } else if (value >= 3 && value <= 3.49) {
      this.ratingStatus = 'average';
    } else if (value >= 2.5 && value <= 2.999) {
      this.ratingStatus = 'below_average';
    } else if (value >= 2 && value <= 2.49) {
      this.ratingStatus = 'poor';
    } else if (value >= 1.5 && value <= 1.999) {
      this.ratingStatus = 'v_poor';
    } else if (value >= 1 && value <= 1.49) {
      this.ratingStatus = 'junk';
    }
  }

  getInfo() {
    this.sharedService.vinInformation.subscribe((res) => {
      if (res && Object.keys(res).length) {
        this.cod = +res['cod_id'].value || 0;
      }
    });
  }

  public vehicleWalkIn: Record<any, any> | null = null;
  getVehicleInfo() {
    this.loaded = true;
    let data: object = { vehicle_id: this.sharedService.getVehicleId };

    this.userService.GetVinInfo(data).subscribe(
      (res) => {
        this.loaded = false;

        let data = res['data'];
        if (res['success'] && Object.keys(data).length) {
          this.vehicleWalkIn = data['vehicle_details']['vehicle_walkin'];
          this.vehicleDetails = data['vehicle_details'];
          this.vehicleInformation = data['vehicle_information'];
          // if (!this.vehicleInformation['calculated_value'] || !this.vehicleInformation['perceived_value']) {
          //   this.modalService.show(TemplateModalComponent, {
          //     ignoreBackdropClick: true
          //   });
          // }

          this.itemCode = this.vehicleInformation
            ? this.vehicleInformation['vehicle_item_code']
            : null;
          this.estimateForm
            .get('repair_total_cost')
            .setValue(
              this.vehicleInformation ? this.vehicleInformation['overall_repair_cost'] : ''
            );
          this.estimateForm.get('city_id').setValue(this.vehicleDetails['city'] || '');

          if (+this.vehicleInformation['perceived_value']) {
            let value: number = +this.vehicleInformation['perceived_value'];
            this.ratingStatusChecker(value);
          } else {
            let value: number = +this.vehicleInformation['calculated_value'];
            this.ratingStatusChecker(value);
          }
          this.getAllEstimateData();
        }
      },
      (error: HttpErrorResponse) => {
        this.loaded = false;
      }
    );
  }

  getCities() {
    this.locationService.getCities().subscribe(
      (res) => {
        if (res) {
          let success: boolean = res['success'];
          let data: object[] = res['data'];

          if (success && Object.keys(data).length) {
            this.cities = data;
          }
        }
      },
      (error: HttpErrorResponse) => {}
    );
  }

  existingPurchasePrice: number = 0;
  userBuyDecision: number = 0;
  public sellPrice: number = 0;
  getAllEstimateData() {
    let data: object = { vehicle_id: this.sharedService.getVehicleId };
    /*
    getEstimateDataAll(parameter) function define in estimates.service.ts file
    api call function
    */
    this.estimateService.getEstimateDataAll(data).subscribe(
      (res) => {
        let success = res['success'];
        let data = res['data'];
        if (success && Object.keys(data).length) {
          this.wholeSaleRange = data['whole_sale_range'] || '';
          this.retailRange = data['retail_range'] || '';
          this.estimatedPurchasePrice = data['estimated_purchase_price'];
          this.estimatedSellingPrice = data['estimated_selling_price'];
          this.buyPrice = data['buy_price'];
          if (data['purchase_type'] && !['retail', 'wholesale'].includes(data['purchase_type'])) {
            this.estimateForm.get('purchase_type').setValue(data['purchase_type']);
          }
          this.estimateForm.get('city_id').setValue(data['city_id']);
          this.estimateForm.get('profit_percent').setValue(data['profit_percent']);
          this.estimateForm.get('estimated_selling_price').setValue(data['sell_price']);
          this.estimateForm.get('estimated_purchase_price').setValue(data?.['buy_price']);
          this.estimateForm.get('sales_order').setValue(data['sales_order']);
          this.estimateForm.get('purchase_order').setValue(data['purchase_order']);
          this.estimateForm.get('market_value').setValue(data['whole_sale_range']);

          this.sellPrice = data['sell_price'];
          this.userBuyDecision = data['buy_decision'];

          this.activeSaleSuggestion = data['sell_decision'];
          this.estimateDetails = data;

          this.estimateForm.updateValueAndValidity();
          this.purchaseTypeSelector(data['purchase_type']);
        } else {
          this.toastr.warning(`Estimated data- ${data}`, '', {
            timeOut: 5000
          });
        }
      },
      (error: HttpErrorResponse) => {},
      () => {
        this.vehicleEstimates(
          this.ratingStatus,
          ['wholesale', 'retail'].includes(this.estimateDetails?.['purchase_type'])
            ? ''
            : this.estimateDetails?.['purchase_type']
        );
      }
    );
  }

  getEstimateData(type: string) {
    if (!this.vehicleInformation) {
      this.toastr.warning('Please submit rating first.', 'Warning');
      return false;
    }

    setTimeout(() => {
      let data: object = {
        item_code: this.itemCode,
        mileage: this.vehicleDetails ? this.vehicleDetails['odo_value'] : '',
        purchase_type: type,
        condition: this.ratingStatus,
        service_maintainance: this.vehicleInformation
          ? this.vehicleInformation['service_maintainance']
          : '',
        utility_type: this.vehicleInformation ? this.vehicleInformation['utility_type_id'] : '',
        city_id: this.estimateForm.get('city_id').value || ''
      };

      this.estimateService.getEstimateData(data).subscribe(
        (res) => {
          if (res) {
            let success = res['success'];
            let data = res['data'];

            if (success && Object.keys(data).length) {
              this.estimateForm.get('market_value').setValue(data['range']);
              this.estimateForm.updateValueAndValidity();
            }
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status === 404) {
            this.estimateForm.get('market_value').setValue('');
            this.estimateForm.updateValueAndValidity();

            this.toastr.warning('Data not found', 'Warning');
          } else {
            this.estimateForm.get('market_value').setValue('');
            this.estimateForm.updateValueAndValidity();
            this.toastr.error('Something went wrong', 'Failed');
          }
        }
      );
    }, 0);
  }

  purchaseTypeSelector(value: string) {
    // Enable this if bottom section required
    // this.getEstimateData(value);
  }

  estimatePurchaseTypeSelect(value: string) {
    this.vehicleEstimates(this.ratingStatus, value, value ? true : false);
  }

  estimatedPurchasePriceWOCOD: number = null;
  estimatedSellingPriceWOCOD: number = null;
  calculatePrice() {
    let purchaseControlValue: number = +this.estimateForm.get('market_value').value;
    let costOfRepair: number = +this.estimateForm.get('repair_total_cost').value || 0;
    let profitMargin: number = +this.estimateForm.get('profit_percent').value || 0;

    // EPP = (((100 * purchaseControl)/(100 + PP)) - costOfRepair)
    this.estimatedPurchasePriceWOCOD = +(
      (purchaseControlValue * 100) / (profitMargin + 100) -
      costOfRepair
    );
    this.estimatedSellingPriceWOCOD = +(
      (purchaseControlValue * 100) / (profitMargin + 100) -
      costOfRepair
    );
    this.estimatedPurchasePrice = +(this.estimatedPurchasePriceWOCOD - this.cod).toFixed(2);
    this.estimateForm.get('estimated_purchase_price').setValue(this.estimatedPurchasePrice);
  }

  saveData() {
    if ([this.roleType.purchaser, this.roleType.purchasemanager].includes(this.role)) {
      if (this.estimateDetails?.['purchase_order']) {
        this.toastr.error('Purchase order already created.');
        return;
      } else if (
        Number(this.estimateForm.get('buy_price').value) <
          Number(this.estimatePriceData['purchase_min']) ||
        Number(this.estimateForm.get('buy_price').value) >
          Number(this.estimatePriceData['purchase_max'])
      ) {
        this.toastr.error('Select price between min and max range!');
        return;
      } else if (Number(this.estimateForm.get('buy_price').value) == 0) {
        this.toastr.error('Something went wrong!');
        return;
      }
    }
    if ([this.roleType.salesperson, this.roleType.salesmanager].includes(this.role)) {
      if (
        Number(this.estimateForm.get('sell_price').value) >
          Number(this.estimatePriceData['sales_max']) ||
        Number(this.estimateForm.get('sell_price').value) <
          Number(this.estimatePriceData['sales_min'])
      ) {
        this.toastr.error('Select price between min and max range!');
        return;
      }
    }

    this.estimateForm.get('buy_decision').setValue(this.activePurchaseSuggestion);
    // this.estimateForm.get('sell_decision').setValue(this.saleApproveStatus);

    if (
      !this.estimateForm.get('purchase_order').value &&
      this.estimateForm.get('buy_decision').value &&
      this.purchaseApproveStatus === 1 &&
      ['admin', 'purchasemanager'].includes(this.role) &&
      !this.vehicleWalkIn
    ) {
      this.estimateForm.get('purchase_order').setValue(uuidv4());
    }

    // this.estimateForm.get('estimated_purchase_price').setValue(null);
    const data: object = {
      vehicle_id: this.sharedService.getVehicleId,
      ...this.estimateForm.value
    };

    this.submitted = true;
    if (this.estimateForm.invalid) {
      return false;
    }

    this.estimateService
      .setEstimateData(data)
      .pipe(
        switchMap(() =>
          this.role === 'evaluator'
            ? this.estimateService.updateRevamCount({
                vehicle_id: this.sharedService.getVehicleId
              })
            : of(null)
        ),
        tap(() => {
          this.adminAlert();
          this.router.navigate([`/vam/gallery`]);
        }),
        finalize(() => {
          this.submitLoad = false;
        })
      )
      .subscribe({
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error?.['errors'] || 'Something went wrong.');
        }
      });
  }

  estimatePriceData: any = null;

  purchaseMinVal: number = 0;
  purchaseMaxVal: number = 0;

  saleMinVal: number = 0;
  saleMaxVal: number = 0;

  purchaseOptions: Options = {
    floor: 0,
    ceil: 0
  };
  saleOptions: Options = {
    floor: 0,
    ceil: 0
  };

  isEstimateUpdated: boolean = true;
  isErrorInEstimates: boolean = false;
  vehicleEstimates(condition: string, purchase_types_id: string, isChange: boolean = false) {
    this.loaded = true;
    this.isErrorInEstimates = false;
    let getVehicleId = JSON.parse(localStorage.getItem('vinInfo'));

    const data = {
      vehicle_id: this.sharedService.getVehicleId,
      item_code: this.itemCode,
      market_acceptability: getVehicleId?.market_acceptabilitie_id?.id,
      condition: condition,
      purchase_types_id: purchase_types_id ? purchase_types_id : ''
    };

    this.estimateService.vehicleEstimates(data).subscribe(
      (response: any) => {
        if (response.success) {
          this.loaded = false;
          this.estimatePriceData = response.data;
          this.estimateForm
            .get('market_value')
            .setValue(+this.estimatePriceData['market_value'].toFixed(2));
          if (this.userBuyDecision) {
            this.activePurchaseSuggestion = Number(this.userBuyDecision);
          } else {
            this.activePurchaseSuggestion = Number(this.estimatePriceData.estimate);
          }
          // isChange is for change event only, to show the change value
          if (this.estimateDetails && !isChange) {
            this.purchaseMinVal = Number(
              this.estimateDetails['buy_price'] || response.data.purchase_min
            );
            this.saleMaxVal = Number(
              this.estimateDetails?.['sell_price'] || response.data.sales_max
            );
          } else {
            this.purchaseMinVal = Number(response.data.purchase_min);
            this.saleMaxVal = Number(response.data.sales_max);
          }

          this.purchaseMaxVal = Number(response.data.purchase_max);
          this.saleMinVal = Number(response.data.sales_min);

          if (
            ['salesmanager', 'salesperson', 'admin'].includes(this.role) ||
            this.estimateDetails?.['sell_price']
          ) {
            this.estimateForm.get('sell_price').setValue(this.saleMaxVal);
            this.estimateForm.get('estimated_selling_price').setValue(this.saleMaxVal);
          }
          if (
            ['admin', 'purchasemanager', 'purchaser'].includes(this.role) ||
            this.estimateDetails?.['buy_price']
          ) {
            this.estimateForm.get('buy_price').setValue(this.purchaseMinVal);
            this.estimateForm.get('estimated_purchase_price').setValue(this.purchaseMinVal);
          }
          this.estimateForm.updateValueAndValidity();

          // this.purchaseOptions.floor = Number(response.data.purchase_min);
          // this.purchaseOptions.ceil = this.purchaseMaxVal;
          // this.saleOptions.floor = +response.data.sales_min;
          // this.saleOptions.ceil = +response.data.sales_max;
          // if(isChange) {
          this.purchaseOptions = {
            floor: +response.data.purchase_min,
            ceil: +response.data.purchase_max
          };
          this.saleOptions = {
            floor: +response.data.sales_min,
            ceil: +response.data.sales_max
          };
          // }else {

          // }
          this.isEstimateUpdated = true;
        }
      },
      (error: HttpErrorResponse) => {
        this.isErrorInEstimates = true;
        this.loaded = false;
      }
    );
  }

  sliderEve(ev: any, type: 'buy_price' | 'sell_price') {
    if (type === 'buy_price') {
      this.estimateForm.get('buy_price').setValue(ev.value);
      this.estimateForm.get('estimated_purchase_price').setValue(ev.value);
    } else if (type === 'sell_price') {
      this.estimateForm.get('sell_price').setValue(ev.value);
      this.estimateForm.get('estimated_selling_price').setValue(ev.value);
    }
    this.estimateForm.updateValueAndValidity();
  }

  priceChangeVal(ev: any, type: 'buy_price' | 'sell_price') {
    if (type === 'buy_price') {
      this.purchaseMinVal = ev.target.value;
    } else if (type === 'sell_price') {
      this.saleMaxVal = ev.target.value;
    }
    this.estimateForm.updateValueAndValidity();
  }

  openModal(estimator_status: TemplateRef<any>) {
    this.modalRef = this.modalService.show(estimator_status);
  }

  alertTo: 'alert_pm' | 'alert_sm';
  adminAlert() {
    const data = {
      vehicle_id: this.sharedService.getVehicleId,
      alert_pm: [RoleType.purchasemanager].includes(this.role) ? 0 : 1,
      alert_sm: [RoleType.salesmanager].includes(this.role) ? 0 : 1
    };

    if ([RoleType.purchasemanager, RoleType.purchaser].includes(this.role)) {
      delete data.alert_sm;
    } else if ([RoleType.salesmanager, RoleType.salesperson].includes(this.role)) {
      delete data.alert_pm;
    }

    this.estimateService.adminAlert(data).subscribe((response) => {});
  }

  public isAlert: boolean = false;
  public isSalesAlert: boolean = false;
  public alertInfo: any = null;
  checkAlert() {
    const data = {
      vehicle_id: this.sharedService.getVehicleId
    };

    this.estimateService.checkAlert(data).subscribe((response) => {
      if (response['success']) {
        this.alertInfo = response['data'];
        this.isAlert = response['data'].alert_pm;
        this.isSalesAlert = response['data'].alert_sm;
      }
    });
  }

  purchaseApproveStatus: 1 | 2 | 0 = 0;
  purchaseApproval(value: 1 | 2) {
    const data = {
      vehicle_id: this.sharedService.getVehicleId,
      status: value
    };
    this.purchaseApproveStatus = value;
    this.estimateService.purchaseApproval(data).subscribe((response) => {
      this.isAlert = false;
    });
  }

  saleApproveStatus: boolean = false;
  salesupdateAlert(value: boolean) {
    const data = {
      vehicle_id: this.sharedService.getVehicleId,
      status: value
    };
    this.saleApproveStatus = value;
    this.estimateService.salesupdateAlert(data).subscribe((response) => {
      this.activeSaleSuggestion = this.estimateDetails?.sell_decision;
      this.estimateForm.get('sell_decision').setValue(value);
      this.isSalesAlert = false;
    });
  }
  onChangeYear(ev: any) {}

  purchaseList: Record<string, any>[] = [];
  getPurchaseType() {
    this.estimateService.purchaseTypeList().subscribe(
      (res) => {
        if (res['success']) {
          this.purchaseList = res['data'];
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }
}
